import Wrapper from '@app/Wrapper.js'

Munio.CoursePackageManager = class CoursePackageManager extends Wrapper {
  component() {
    return import('./App.vue')
  }
}
